module.exports = __webpack_public_path__ + "static/chocolate_rose_alice-494531e2626aee0f27b575f1f71e8fdd.jpg";